import { assocPath, compose, curry, propOr } from 'ramda';
import { dotPath as getInPath } from 'ramda-extension';

import { splitPath } from 'utils/helpers';

export const empty = {};

export const createFetchState = (
	isFetching = false,
	loaded = false,
	error = false,
	metaData = empty,
	lastRequest = empty,
) => ({
	isFetching,
	loaded,
	error,
	metaData,
	lastRequest,
});

export const defaultFetchState = createFetchState();

/**
 * Helper for fetch store
 * if item in fechStore dose not have initial state this function will return empty object
 * so component dose not drop on undefined
 */

export const checkIfNull = (x) => (x ? x : empty);

export const updateData = curry((path, value, state) => assocPath(splitPath(path), value, state));

export const getMetaData = (path) => compose(propOr(empty, 'metaData'), getInPath(path));

export const getLastRequest = (path) => compose(propOr(empty, 'lastRequest'), getInPath(path));
